import { fetchData } from '../../../../helpers/base_data_fetcher';

export default {
  getSiteData: () => fetchData('site'),
};
